<template>

  <div>

    <!-- info row -->
    <div class="row invoice-info">
      <div class="col-sm-4 invoice-col">

        <h5 v-if="order.buyer"> {{ order.buyer.note + ' ' + order.buyer.nationalCode }}
          <!--        <router-link class="btn btn-xs" :to="`/profile/`+order.contact.id"></router-link>-->
        </h5>


        <br>
        <address>
          <b-badge v-if="order.payType" variant="success" class="control-label">
            نوع سند:

            <span v-if="order.payType == 'cash'">
              نقدی
              </span>
            <span v-if="order.payType != 'cash'">
              نسیه
              </span>



          </b-badge>
          <!--        <b-badge v-if="order.state == 1" variant="danger" class="control-label mx-1">پیش فاکتور</b-badge>-->


          <br>
          <br>
          <!--                                {{ $t('phone') }} : {{order.user.mobile}}-->
          <!--                        /  {{ $t('e-mail') }} : {{order.user.email}}-->

        </address>
      </div>
      <!-- /.col -->
      <div class="col-sm-1 invoice-col">

      </div>
      <!-- /.col -->
      <div class="col-sm-7 invoice-col">
        <small> کد سیستمی: {{ order.factorId }}</small> <hr>
        <b> شماره فاکتور {{ order.code }}</b>
        <br>
        <span
            :class="`badge `+stateColor(order.state)">{{ stateorder(order.state) }}</span>


        <br>
        <b> </b> {{ order.title }}<br>
        <b>تاریخ فاکتور: {{ order.factorDate | moment("dddd, jD jMMMM  jYYYY") }}</b> <br>
        <span>تاریخ ثبت: {{ order.factorDate | moment("dddd, jD jMMMM  jYYYY") }}</span> <br>
        <br>
        <!--                    <b>{{ $t('Visit time') }}:</b> {{order.general_start}}<br>-->
        <!--                    <b>{{ $t('End time') }}:</b> {{order.general_end}}-->
        <div class="page-header" v-if="order.product_serial || order.product_reference || order.description">
          <!--                        <i class="fa fa-globe"></i> -->
          شماره فاکتور:
          <small class="pull-left">{{ order.product_serial }} </small>


          <br>
<!--          <small class="pull-left">{{ order.product_reference }} </small>-->


          <br>
          شرح:
          <small class="pull-left">{{ order.note }} </small>
          <br><br><br><br><br><br>
        </div>
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->

    <!-- Table row -->
    <div class="row">
      <div class="col-xs-12 table-responsive">
        <table class="table table-striped">
          <!--                        <thead>-->
          <!--                            <tr>-->
          <!--                                <th>{{ $t('QTY') }}</th>-->
          <!--                                <th>{{ $t('services') }}</th>-->
          <!--                                <th>{{$personel}}</th>-->
          <!--                                &lt;!&ndash;<th>سریال</th>&ndash;&gt;-->
          <!--&lt;!&ndash;                                <th>{{ $t('start time') }} </th>&ndash;&gt;-->
          <!--&lt;!&ndash;                                <th>{{ $t('End Time') }} </th>&ndash;&gt;-->
          <!--                                &lt;!&ndash; <th>سریال</th> &ndash;&gt;-->
          <!--                                <th>{{ $t('Description') }}</th>-->
          <!--                                <th>{{ $t('Total price') }}</th>-->
          <!--&lt;!&ndash;                                <th>{{ $t('Survey') }}</th>&ndash;&gt;-->
          <!--                                <th>-->
          <!--                                    <button  v-on:click="alert"  type="button" class="btn btn-success btn-modal btn-sm" data-toggle="modal"-->
          <!--                                            data-target="#contact"><i class="fa fa-plus"></i></button>-->
          <!--                                </th>-->
          <!--                            </tr>-->
          <!--                        </thead>-->
          <tbody>
          <tr v-for="(order_service, index) in order.order_services" :key="index">
            <td style="color: #00bfa5">{{ index + 1 }}</td>
            <td><span v-if="order_service.service">{{ order_service.service.title }}</span></td>
            <td> {{ order_service.number }}</td>
            <td style="color: #00bfa5">آیتم خدمت</td>

            <td>

                    <span>
                         <span
                             v-if="!order_service.discount">{{
                             spliceNumber(order_service.price)
                           }}{{ $curency }}</span>
                    <span v-else>
                                        {{ spliceNumber(order_service.price - order_service.discount) }}{{ $curency }}
                                    </span>
                    </span>

            </td>


            <!--<td>{{order_service.order_id}}-{{order_service.id}}</td>-->
            <!--                                <td>{{ order_service.start }}</td>-->
            <!--                                <td> {{ order_service.end }}</td>-->

            <td>
                                           <span v-if="order_service.person">{{ order_service.person.name }}
                                        {{ order_service.person.family }} - </span>
              <span v-else></span>
              <small>{{ order_service.note }}</small>
            </td>

            <td>
                    <span>
                                    <span
                                        v-if="!order_service.discount">{{
                                        spliceNumber(order_service.price)
                                      }}{{ $curency }}</span>
                    <span v-else>
                                        {{ spliceNumber(order_service.price - order_service.discount) }}{{ $curency }}
                                    </span>
                      </span>
            </td>


            <!--                                <td>-->
            <!--                                    <span v-if="order_service.feedback">-->
            <!--                                        <div class="tooltipmain">{{ order_service.feedback.comment }}-->
            <!--                                            <span class="tooltiptextmain">-->
            <!--                                                <star-rating :value="order_service.feedback.rate"></star-rating>-->
            <!--                                            </span>-->
            <!--                                        </div>-->


            <!--                                    </span>-->
            <!--                                    <span v-else></span>-->
            <!--                                </td>-->

            <td></td>

            <td>
              <!-- //////////////////////////////////////////////// -->
              <!--            <button v-if="edit" type="button" class="btn btn-default btn-modal btn-sm" data-toggle="modal"-->
              <!--                    :data-target="'#order_service'+order_service.id"><i class="fa fa-edit"></i></button>-->

              <!--            <button  v-if="edit" @click="deleteServiceOrder(order_service.id)" type="button"-->
              <!--                    class="btn btn-outline-danger btn-sm"><i class="fa fa-trash"></i></button>-->


            </td>


            <!-- Modal -->
            <div :id="'order_service'+order_service.id" class="modal fade" role="dialog">
              <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title"> ویرایش قیمت آیتم خدمت</h4>
                  </div>


                  <div class="modal-body">
                    <div style="margin:5px">


                      <div class="col-xs-12 form-group">
                        <label v-if="order_service.service" class="control-label" style="color: #8150e4">
                          {{ order_service.service.title }}
                        </label>
                      </div>


                      <div class="col-xs-12 form-group">
                        <label class="control-label"> {{ $t('Price(toman)') }}
                          ({{ spliceNumber(order_service.price) }} {{ $curency }})
                        </label>
                        <input type="text" v-model="order_service.price" class="form-control">


                        <br>
                        <label class="control-label"> شرح آیتم
                        </label>
                        <input type="text" v-model="order_service.note" class="form-control">


                      </div>

                      <div class="col-xs-12 form-group">
                        <label class="control-label">{{ $personel }}</label>

                        <select class="form-control" v-model='order_service.person_id'>
                          <option v-for="(person,index) in order_service.service.persons"
                                  :value="person.id" :key="index">
                            <!-- here -->
                            {{ person.name }} {{ person.family }}
                          </option>
                        </select>

                      </div>

                    </div>
                    <br>

                    <button v-if="edit" v-on:click="updateServiceItem(order_service)" data-dismiss="modal"
                            class="btn btn-success">بروزرسانی
                    </button>

                    <button v-if="edit" type="button" class="btn btn-default" data-dismiss="modal">بستن</button>
                  </div>
                </div>
                <!-- <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>

                </div> -->
              </div>


            </div>


            <!-- {{ order_service }} -->
          </tr>

          </tbody>

          <thead v-if="order.items.length !==0">
          <tr>
            <th></th>

            <th>{{ $t('Good') }}</th>
            <th>مقدار/تعداد</th>
            <th>{{ $t('unit') }}</th>

            <th>قیمت واحد</th>
            <th>{{ $t('Total price') }}</th>
            <th>تخفیف</th>
            <th>مالیات</th>

            <th>{{ $t('Description') }}</th>


            <th class="text-left">
              <!-- //////////////////////////////////////////////// -->

              <!--            <button  v-if="edit"  type="button" class="btn btn-success btn-modal btn-sm" data-toggle="modal"-->
              <!--                    data-target="#add-order-product"><i class="fa fa-plus"></i></button>-->
              <!--            <button  v-if="edit"  type="button" class="btn btn-outline-success btn-outline btn-modal btn-sm"-->
              <!--                    data-toggle="modal"-->
              <!--                    data-target="#add-order-service"><i class="fa fa-plus"></i></button>-->
            </th>
          </tr>
          </thead>
          <thead v-else>
          <tr>


            <td>

              <!-- //////////////////////////////////////////////// -->

              <!--            <button  v-if="edit"  type="button" class="btn btn-success btn-modal btn-sm" data-toggle="modal"-->
              <!--                    data-target="#add-order-product"><i class="fa fa-plus"></i> افزودن آیتم کالا-->
              <!--            </button>-->

              <!--            <button  v-if="edit" type="button" class="btn btn-outline-success btn-outline btn-modal btn-sm"-->
              <!--                    data-toggle="modal"-->
              <!--                    data-target="#add-order-service"><i class="fa fa-plus"></i> افزودن آیتم خدمات-->
              <!--            </button>-->
            </td>

          </tr>
          </thead>
          <tbody v-if="order.items.length !== 0">
          <tr v-for="(item,index) in order.items" :key="index">
            <th>{{ index + 1 }}</th>
            <td><span v-if="item.product">{{ item.product.name }}</span> -
              <small>{{ item.product.code }} </small></td>
            <td> {{ item.amount }}</td>
            <td>
              <div v-if="item.product">
              <span v-if="item.product.unit">
                {{ item.product.unit.name }} - <small> {{ item.product.unit.code }} </small>
              </span>
              </div>
            </td>
            <td>
                    <span>
                    {{ spliceNumber(item.price) }} {{ $curency }}
                  </span></td>

            <td> <span>
                                        {{ spliceNumber(item.price * item.amount) }} {{ $curency }}

                  </span>
            </td>

            <td>

            <span v-if="item.discount">
                 {{ item.discount }}
            </span>

            </td>

            <td>

            <span v-if="item.tax">
                 {{ item.tax }}
            </span>

            </td>


            <!--<td>{{ item.tax }}</td>-->


            <td><small>{{ item.note }}</small></td>


            <!--                                <td>-->
            <!--                                    <span v-if="order.order_products.feedback">-->


            <!--                                        <div class="tooltipmain">{{ order.order_products.feedback.comment }}-->
            <!--                                            <span class="tooltiptextmain">-->
            <!--                                                <star-rating :value="order.order_products.feedback.rate"></star-rating>-->
            <!--                                            </span>-->
            <!--                                        </div>-->
            <!--                                    </span>-->
            <!--                                    <span v-else></span>-->
            <!--                                </td>-->

            <td>
              <!--- ///////////////////////////////////////-->
<!--              <button v-if="edit" type="button" class="btn btn-default btn-modal btn-sm" data-toggle="modal"-->
<!--                      :data-target="'#order_product'+item.id"><i class="fa fa-edit"></i></button>-->
<!--              <button v-if="edit" @click="deleteProductOrder(item.id)" type="button"-->
<!--                      class="btn btn-outline-danger btn-sm"><i-->
<!--                  class="fa fa-trash"></i></button>-->

            </td>


            <!-- Modal -->
            <div :id="'order_product'+item.id" class="modal fade" role="dialog">
              <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title"> ویرایش قیمت </h4>
                  </div>


                  <div class="modal-body">
                    <div style="margin:5px">


                      <div class="col-xs-12 form-group">
                        <label v-if=" item.product" class="control-label" style="color: #8150e4"> {{
                            item.product.title
                          }}
                        </label>
                      </div>


                      <div class="col-xs-12 form-group">

                        <label class="control-label"> {{ $t('Price(toman)') }} ({{ spliceNumber(item.price) }}
                          {{ $curency }})
                        </label>
                        <input type="text" v-model="item.price" class="form-control">
                        <br>
                        <label class="control-label"> مقدار/تعداد
                        </label>
                        <input type="text" v-model="item.amount" class="form-control">
                        <br>
                        <label class="control-label">واحد </label>
                        <select class="form-control form-control-sm" v-model="item.unit">
                          <option v-for="(unit,index) in units" :value="unit.id" :key="index">
                            {{ unit.title }}
                          </option>
                        </select>
                        <br>
                        <label class="control-label"> شرح آیتم
                        </label>
                        <input type="text" v-model="item.note" class="form-control">
                      </div>


                    </div>
                    <br>

                    <button v-if="edit" v-on:click="updateProductItem(item)" data-dismiss="modal"
                            class="btn btn-success">
                      بروزرسانی
                    </button>

                    <button v-if="edit" type="button" class="btn btn-default" data-dismiss="modal">بستن</button>
                  </div>
                </div>
                <!-- <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>

                </div> -->
              </div>


            </div>


          </tr>
          </tbody>
        </table>
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->

    <div class="row">
      <!-- accepted payments column -->
      <div class="col-xs-6">


        <!--<p class="text-muted well well-sm no-shadow" style="margin-top: 10px;">-->
        <!--شرح:-->
        <!--{{ order }}.description}}-->


        <!--</p>-->

        <!--<br>-->

        <!--                    <div class="row discunt" >-->
        <!--                        <div class="col-xs-12 form-group">-->
        <!--                            <label class="control-label">{{ $t('Discount or credit code entry') }} </label>-->
        <!--                            <input type="text" v-model="discountCode" class="form-control">-->
        <!--                        </div>-->
        <!--                        <div class="col-xs-12 form-group">-->
        <!--                            <button v-on:click="applyDiscountToOrder" class="btn btn-sm">{{ $t('Apply a discount code') }}</button>-->
        <!--                        </div>-->
        <!--                    </div>-->

      </div>
      <!-- /.col -->
      <div class="col-xs-6">
        <!-- <p class="lead"> تاریخ: {{order.description | moment("dddd, jD jMMMM  jYYYY")}}</p> -->
        <hr>
        <div class="table-responsive maintable">
          <table class="table ">

            <tr v-if="order.discount && order.discount != ''">
              <th style="width:50%">{{ $t('Total Amount') }}:</th>
              <td>
                      <span>
<!--                         {{ spliceNumber(order.price + order.general_discount) }} {{ $curency }}-->
                      </span>
              </td>
            </tr>
            <!--<tr>-->
            <!--<th>مالیات (9.3%)</th>-->
            <!--<td>{{order.general_tax}} </td>-->
            <!--</tr>-->

            <!---- //////////////////////////-->
<!--            <button v-if="edit" type="button" class="btn btn-default btn-modal btn-sm" data-toggle="modal"-->
<!--                    data-target="#editOrder"><i class="fa fa-edit"></i></button>-->
            <tr v-if="order.discount">
              <th>{{ $t('Discount') }}</th>
              <!--            <td>{{ spliceNumber(order.discount) }}{{ $t('') }} {{ $curency }}</td>-->
            </tr>
            <!--          <tr v-else>-->
            <!--            <th>-->
            <!--              {{ $t('Discount') }}-->
            <!--            </th>-->
            <!--            <td>0</td>-->
            <!--          </tr>-->


            <tr v-if="order.discount && order.discount != ''" style="color: #aa0c5f;">


              <th v-if="order.discount.amount_type == '0'" colspan="2">
                {{ order.discount[0].amount }}{{ $t('Discount Percentage as') }}
                "{{ order.discount[0].title }}"{{ $t('Subtracted from total amount') }}
              </th>
              <th v-else colspan="2"> {{ $t('Credit discount with title') }} "{{ order.discount[0].title }}"
                {{ $t('Subtracted from total amount') }}
              </th>
            </tr>

            <tr>
              <th colspan="2">
                <hr>
              </th>
            </tr>
            <tr style="font-size: 16px; padding-top: 10px">
              <th style="color: #009101;">مبلغ کل:</th>
              <td style="font-weight: bold">
                      <span>
                        {{ spliceNumber(sumPrice(order.items)) }} {{ $curency }}
                      </span></td>
            </tr>


            <tr v-if="contactsPayments >= contactsOrders">
              <th v-if="edit" colspan="2">
                <hr>
<!--                {{ $t('Payment receipt successfully deducted from customer credit') }}-->
              </th>


            </tr>
            <tr v-else>
              <td style="color: #ff5444;">{{ $t('Balance payable') }} :</td>
              <td style="font-weight: bold">
                      <span>
<!--                        {{ spliceNumber(-(contactsPayments - contactsOrders)) }}-->
                      {{ $curency }}
                      </span>
              </td>
            </tr>


            <!--          <tr class="form-group" v-if="contactsPayments > contactsOrders">-->
            <!--            <td style="color: #222;"> {{ $t('Extra customer credit') }} :</td>-->
            <!--            <td style="font-weight: bold">{{ spliceNumber(contactsPayments - contactsOrders) }} {{ $curency }}-->
            <!--            </td>-->
            <!--          </tr>-->

          </table>
        </div>
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->


  </div>

</template>

<script>
import InnerImageZoom from 'vue-inner-image-zoom';


const auth = {
  headers: {
    Authorization: 'bearer ' + localStorage.getItem('token')
  }
};


export default {

  name: 'order-invoice',

  components: {
    'inner-image-zoom': InnerImageZoom
  },

  props: {
    order: {},
    edit: true,

  },

  data() {
    return {

      auth: {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token')
        }
      },
      placeholder: "فایل را انتخاب کنید...",

      // order: {},
      paymentAccount: '',
      accounts: [],
      discountCode: '',
      reminderItems: '',
      remainder: {},
      loader: false,
      remainerlist: [],
      note: {
        comment: '',
        rate: '0',
        contact_id: '',
        order_id: '',
        image: '',
      },


      contactsOrders: 0,
      contactsPayments: 0,
      orderPayments: 0,

      paymentAmount: 0,

      personsOrderServices: {},


      productOrder: {
        product_id: '',
        unit: '',
        amount: 1,
        note: '',
        price: 0,
        // item: '',
        accounting_code_id: '',
      },

      serviceOrder: {
        service_id: '',
        number: 1,
        note: '',
        price: 0,
        accounting_code_id: '',
      },


      accountingCodes: [],
      products: [],
      services: [],

      projects: [],
      contacts: [],
      units: [],


      inventories: [],


      loadingInv: {
        inventory_id: '',
        order_item_id: '',
        amount: 0
      }

    }
  },

  mounted() {
    // this.getUnits();

  },


  methods: {

    sub(str) {
      if (str != null) {
        return str.substring(0, 5)
      }

    },

    pluck(array, key) {
      return array.map(function (obj) {
        return obj[key];
      });
    },

    totalSum(items) {

      var total = 0;

      this.pluck(items, 'price').forEach(function (element) {
        console.log(element)

        total = Number(total) + Number(element)

      });

      return total;
    },


    isActive() {

      if (this.order.state > 0)
        return true
      else
        return false


    },


    spliceNumber(number) {
      //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

      $("input[data-type='number']").keyup(function (event) {
        var $this = $(this);
        var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
        $this.val(num2);
      });
      if (number != null && number != "") {
        return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
      }

    },


    stateColor(index) {
      switch (index) {

        case '0':
          return "badge-info"
          break;
        case '1':
          return 'badge-danger'
          break;
        case '2':
          return 'badge-success'
          break;
        case '3':
          return "badge-primary"
          break;
        default:
          break;
      }
    },

    stateorder(index) {
      switch (index) {

          case 'type1':
          return 'نوع اول'
          break;
          case 'type2':
          return 'نوع دوم'
          break;
          case '0':
          return 'ثبت اولیه'
          break;
        case '1':
          return 'برگشت خورده'
          break;
        case '2':
          return 'پرداخت شده'
          break;
        case '3':
          return 'ثبت نهایی سند'
          break;
        default:
          break;
      }
    },


    filteritemType(item) {

      var unit = null
      if (unit = this.units.find(x => x.id == item))
        return unit.title
      else return 'نامشخص'

      // switch (item) {
      //     case '0':
      //         return  this.$t('Number')
      //         break;
      //     case '1':
      //         return  this.$t('g')
      //         break;
      //     case '2':
      //         return  this.$t('Kg')
      //         break;
      //     case '3':
      //         return   this.$t('Liter')
      //         break;
      //     case '4':
      //         return  this.$t('packet')
      //         break;
      //     default:
      //         return  this.$t('Unknown')
      // }
    },

    getUnits() {
      axios
          .get('/api/unitList', this.auth)
          .then(response => {

            this.units = response.data;
          })
          .catch(error => {
            console.log(error);
            this.errored = true
          })
    },

    sumPrice(items) {
      //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

      console.log(items)
      let sum= 0;
      items.forEach((item)=>{
        if (item.tax== null || item.tax =='')
          item.tax=0
        if (item.discount== null || item.discount =='')
          item.discount=0

        sum += Math.round(((item.price * item.amount)- item.discount)*(item.tax+1))

      }

     )

      return sum;
    },


  }

}
</script>
